module.exports = __webpack_public_path__ + "static/site-1748617940196/img/logo_maestro.0e3ebe42.png";